import { LOOP_FALLBACK_APPROACH } from "../../../../utils/constant";

export const GTM_EVENTS = {
  RESCHEDULE_OPENED: "reschedule_opened",
  DATE_SELECTED: "reschedule_date_selected",
  TIME_SELECTED: "reschedule_time_selected",
  NO_SLOTS: "reschedule_no_slots",
  RESCHEDULE_CLICKED: "reschedule_clicked",
  CANCEL_CLICKED: "cancel_clicked",
  // Misspelt in V2; kept so analytics stay continuous across the revamp.
  RESCHEDULE_SUBMITTED: "reshedule_submitted",
  SUBSTITUTE_SUBMITTED: "reschedule_alternate_submitted",
  CANCEL_SUBMITTED: "cancel_submitted",
};

export const ACTION_CUTOFF_MINUTES = 60;
export const DEFAULT_TIME_ZONE = "Asia/Kolkata";
// An on-request reschedule's outcome says what happens if the mentor declines (a substitute is
// arranged), which takes longer to read than a one-line result, so it waits longer and offers a way
// to leave sooner.
export const REDIRECT_SECONDS = { DEFAULT: 3, ON_REQUEST: 10 };
export const CANCEL_REASON = "Student Unavailable";
export const REQUESTER_TYPE = "student";
export const OTP_TYPE = "reschedule-cancel";
export const OTP_LENGTH = 4;

// The design promises a substitute when the mentor declines and offers no choice;
// V2's on-request modal defaulted to the same approach.
export const ON_REQUEST_FALLBACK_APPROACH = LOOP_FALLBACK_APPROACH.TEACHER_SUBSTITUTION;

// Morning, Afternoon, Evening — the ids slotUtils' TIME_RANGES and getFilteredSlots use.
export const TIME_RANGE_IDS = [1, 2, 3];
export const DEFAULT_TIME_RANGE_ID = 1;

export const DATE_FORMATS = {
  DAY_KEY: "DD MMM YYYY (ddd)",
  TIMING: "YYYY-MM-DD HH:mm:ss",
  CLASS_DATE_TIME: "DD MMM YYYY, hh:mm A",
  TIME: "hh:mm A",
  TIME_COMPACT: "hh:mmA",
  SUBSTITUTION_DATE: "DD MMM YYYY",
  SUBSTITUTION_TIME: "HH:mm",
  CUTOFF_COMPARE: "YYYY/MM/DD HH:mm:ss",
};

export const SLOT_KIND = {
  AVAILABLE: "available",
  ON_REQUEST: "onRequest",
  OCCUPIED: "occupied",
};

export const SLOT_ACTION = {
  CONFIRM_RESCHEDULE: "confirmReschedule",
  MENTOR_BUSY: "mentorBusy",
  ON_REQUEST: "onRequest",
};

export const RESCHEDULE_QUOTA = {
  HIDDEN: "hidden",
  AVAILABLE: "available",
  USES_CANCELLATION: "usesCancellation",
  USES_FINAL_CLASS: "usesFinalClass",
  BLOCKED: "blocked",
};

// What `GET /class/reschedule/schedule` returns in `mode` (SPRIN-3248). The server walks the whole
// ladder — group course, policy order, balances, flex — and sends the answer, so the page never
// re-derives it from balances: the counts are rebuilt by a job every ~10 minutes and can disagree.
// Absent (the edit-class gate is off on StudentPortalApi) reads as NONE, which is today's flow.
export const RESCHEDULE_MODE = {
  NONE: "none",
  CANCELLATION: "cancellation",
  LAST_CLASS: "lastClass",
  BLOCKED: "blocked",
};

export const CANCEL_NOTICE = {
  FLEX: "flex",
  LIMIT_EXCEEDED: "limitExceeded",
  BLOCKED: "blocked",
  MOVES_TO_END: "movesToEnd",
};

export const OUTCOME = {
  CANCELLED: "cancelled",
  RESCHEDULED: "rescheduled",
  LOOP_REQUEST_RECEIVED: "loopRequestReceived",
  SUBSTITUTE_REQUEST_RECEIVED: "substituteRequestReceived",
};

export const FOCUSABLE_SELECTOR =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export const NATIVE_MESSAGE_TYPE = {
  ROUTE: "route",
  SLOT_SELECTOR_STATE: "slotSelectorState",
  GO_BACK: "goBackToMainScreen",
};

// Slot dialogs share SLOT_ACTION's values so a slot's action names its dialog.
export const DIALOG_TYPE = {
  CONFIRM_RESCHEDULE: SLOT_ACTION.CONFIRM_RESCHEDULE,
  MENTOR_BUSY: SLOT_ACTION.MENTOR_BUSY,
  ON_REQUEST: SLOT_ACTION.ON_REQUEST,
  CANCEL_CONFIRM: "cancelConfirm",
  ERROR: "error",
};

export const EDIT_ACTION = {
  RESCHEDULE: "reschedule",
  CANCEL: "cancel",
};

export const OTP_RESEND = "resend";

// Three full rows of the three-column grid.
export const SLOT_SKELETON_COUNT = 9;

// The outcome's shell: 734px (a request), 614px (a reschedule), and the cancelled screen's own
// smaller card (233:8816).
export const OUTCOME_SIZE = {
  DEFAULT: "default",
  COMPACT: "compact",
  CANCELLED: "cancelled",
};

// The design's one layout breakpoint; the CSS Modules use the same width.
export const COMPACT_SCREEN_QUERY = "(max-width: 600px)";

// V2 forced a white body while the page was mounted.
export const PAGE_BODY_BACKGROUND = "#fff";
